import React from 'react'
import { renderToString } from 'react-dom/server'
import { Icon, l } from '@manychat/manyui'

import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import {
  ContainerAppearance,
  ContentContainer,
} from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import { NextStep } from 'common/builder/components/chart/FlowChart/components/NextStep/NextStep'
import { QuickReplyButton } from 'common/builder/components/chart/FlowChart/components/QuickReplyButton/QuickReplyButton'
import CachedView from 'common/builder/components/chart/FlowChart/nodes/shared/CachedView/CachedView'
import { ActionConfig } from 'common/builder/components/chart/FlowChart/nodes/shared/config'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon/TextWithIcon'
import { FlowChartUserInputBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartUserInputBlock'

import * as styles from './UserInput.styles'

const DELAY_ICON_STRING = renderToString(<Icon.LiveChat size={64} color="#6449E3" />)

export const UserInputGenericBlock: BlockComponent<FlowChartUserInputBlock> = ({ block }) => {
  const isEmpty = !block.data.question
  const hasButtons = block.data.buttons.length > 0
  const { replyTypeLabel } = block.data

  return (
    <InteractiveBlockContainer id={block.id}>
      <ContentContainer isEmpty={isEmpty}>
        {isEmpty ? (
          <TextWithIcon empty>{l.translate('Enter a question')}</TextWithIcon>
        ) : (
          <richtext style={sharedStyles.text} text={block.data.question} />
        )}
      </ContentContainer>
      <view style={styles.Separator} />
      {hasButtons && (
        <>
          <view style={styles.QuickRepliesRow}>
            {block.data.buttons.map((button) => (
              <React.Fragment key={button.id}>
                <QuickReplyButton button={button} style={styles.QuickReplyButton} />
                <view style={styles.QuickRepliesSpacer} />
              </React.Fragment>
            ))}
          </view>
          <view style={styles.Separator} />
        </>
      )}

      <ContentContainer appearance={ContainerAppearance.DELAY} style={styles.DelayBlock}>
        <TextWithIcon icon={DELAY_ICON_STRING} row multiline>
          {replyTypeLabel
            ? l.translate('Waiting for {replyTypeLabel} from contact...', {
                replyTypeLabel: replyTypeLabel,
              })
            : l.translate('Waiting for reply from contact...')}
        </TextWithIcon>
      </ContentContainer>
      <CachedView id={block.id} style={styles.NextStepWrapper}>
        <sprite image={ActionConfig.icon} style={styles.NextStepIcon} />
        <NextStep nextStep={block.data.nextStep} style={styles.NextStep} />
      </CachedView>
      {block.data.fallbackNextStep !== null && (
        <CachedView id={block.data.fallbackNextStep.id} style={styles.NextStepWrapper}>
          <NextStep nextStep={block.data.fallbackNextStep} style={styles.NextStep} />
        </CachedView>
      )}
    </InteractiveBlockContainer>
  )
}
